"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQrCodeDialog = exports.qrCodeDialog = exports.defaultQrCodeDialogContext = exports.QrCodeDialogProvider = exports.Provider = void 0;
var _react = require("react");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve -- context */

const defaultQrCodeDialogContext = exports.defaultQrCodeDialogContext = {
  url: '',
  imageRef: /*#__PURE__*/(0, _react.createRef)(),
  backgroundColor: _models.QRBackgroundColor.Green,
  textPosition: _models.QRTextPosition.Top,
  setBackgroundColor: () => {},
  setTextPosition: () => {}
};
const qrCodeDialog = exports.qrCodeDialog = /*#__PURE__*/(0, _react.createContext)(defaultQrCodeDialogContext);
const {
  Provider
} = qrCodeDialog;
exports.Provider = Provider;
const imageRef = /*#__PURE__*/(0, _react.createRef)();
const QrCodeDialogProvider = ({
  url,
  gamificationActivityType,
  children
}) => {
  const [backgroundColor, setBackgroundColor] = (0, _react.useState)(_models.QRBackgroundColor.Green);
  const [textPosition, setTextPosition] = (0, _react.useState)(_models.QRTextPosition.Top);
  const value = (0, _react.useMemo)(() => ({
    url,
    imageRef,
    backgroundColor,
    textPosition,
    gamificationActivityType,
    setBackgroundColor,
    setTextPosition
  }), [url, backgroundColor, textPosition, gamificationActivityType]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.QrCodeDialogProvider = QrCodeDialogProvider;
const useQrCodeDialog = () => (0, _react.useContext)(qrCodeDialog);
exports.useQrCodeDialog = useQrCodeDialog;
